import { useContext } from "react";
import { AppContext } from "../context";

const useApp = () => useContext(AppContext);

export default useApp;
